import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Spinner,
  Progress,
  Table,
} from "reactstrap";
import { accessRole } from "../../../../helpers/access_role";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import YearSelect from "../../../../helpers/ui/YearSelect";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvField,
  AvGroup,
  AvCheckboxGroup,
  AvCheckbox,
  AvInput,
} from "availity-reactstrap-validation";

import { Redirect, Link } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";
import { cancelToken } from "../../../../services/adapters/kepegawaian/menuService";

import CustomSelect from "../../GlobalComponents/CustomSelect";

// import AwardBloc from '../Index/Blocs/AwardBloc'
import CreateBloc from "./Blocs/CreateBloc";

let peg_uuid =
  JSON.parse(localStorage.getItem("userdata")) != null
    ? JSON.parse(localStorage.getItem("userdata")).employee_uuid
    : "";

const createYearOption = (startYear = 1980) => {
  debugger;
  var currentYear = 2060, // new Date().getFullYear() + 10,
    years = [];
  startYear = startYear || 1980;
  while (startYear <= currentYear) {
    var newObj = {};
    var year = startYear++;
    newObj["label"] = year;
    newObj["value"] = year;
    years.push(newObj);
  }
  return years;
};

class CreateView extends Component {
  source;
  createBloc = new CreateBloc();
  defaultSize = 10;

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      yearOptions: createYearOption(1980),
    };
  }

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        employee_uuid: peg_uuid,
        ...values,
      },
      confirm: true,
    });
  };

  submitData = async () => {
    await this.createBloc.fetchCreate(this.state.dataForm);
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Card>
            <CardBody style={{ height: "400px" }}>
              <div className="float-end">
                <Link to="/kepegawaian/pemberian_penghargaan.html">
                  <Button outline color="primary">
                    <i className="uil uil-backward"></i> Kembali
                  </Button>
                </Link>
              </div>
              <CardTitle>Tambah Data Periode</CardTitle>
              <hr />
              <AvForm
                className="needs-validation"
                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
              >
                <Row className="mb-3">
                  <Label className="col-md-2 col-form-label">
                    Periode <span className="text-danger">*</span>
                  </Label>
                  <Col md="2">
                    {/* <YearSelect 
                                            name="award_period_date"
                                            placeholder="Periode..."
                                            errorMessage="Masukkan Periode"
                                            validate={{ required: { value: true } }}                                       
                                        /> */}

                    <CustomSelect
                      name="award_period_date"
                      onChange={(selected) => {
                        this.setState({
                          periodeYear: selected.value,
                        });
                      }}
                      errorMessage="Masukkan Periode"
                      options={this.state.yearOptions}
                      validate={{ required: { value: true } }}
                      placeholder="Periode"
                      // defaultValue={new Date().getFullYear()}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Label className="col-md-2 col-form-label">
                    Keterangan <span className="text-danger">*</span>
                  </Label>
                  <Col md="4">
                    <AvField
                      name="award_period_description"
                      placeholder="Keterangan..."
                      type="textarea"
                      errorMessage="Masukkan Keterangan"
                      validate={{ required: { value: true } }}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="2"></Col>
                  <Col md="8">
                    <Link to="/kepegawaian/pemberian_penghargaan.html">
                      <Button color="danger" type="button">
                        <i className="uil-arrow-left"></i> Kembali
                      </Button>
                    </Link>{" "}
                    <Button color="success" type="submit">
                      <i className="uil-arrow-up-right"></i> Simpan Data
                    </Button>
                  </Col>
                </Row>
              </AvForm>
            </CardBody>
          </Card>
        </Container>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin data tersebut sudah benar?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/pemberian_penghargaan.html" />
        ) : null}
      </Fragment>
    );
  }
}

export default CreateView;
